import { css } from 'styled-components';

export default css`
  color: #ececec;
  font-family: 'Oswald', sans-serif;
  font-weight: 300;
  margin: 0 0 1.5rem;
  line-height: 1.2;

  &:last-child {
    margin: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Typography/mixins/HeaderMixin.js